import type { ReactNode } from "react";

import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export type AppSettingsCardProps = {
  children: ReactNode;
  title: string;
  description: string;
};

export const AppSettingsCard = ({
  children,
  title,
  description,
}: Readonly<AppSettingsCardProps>) => {
  return (
    <Card>
      <CardHeader className="border-b border-gray-200 p-4">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-medium">{title}</CardTitle>
          <div className="flex-grow-0">{children}</div>
        </div>
      </CardHeader>
      <CardDescription className="p-4 pt-2">
        <div className="text-sm text-gray-600">{description}</div>
      </CardDescription>
    </Card>
  );
};
